let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2vYpt")).then(() => parcelRequire('jMyUD'));